import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { API_BASE_URL } from '@/services/api/client'
import { getAccessToken } from '@/utils/tokenStorage'

export function TimetableExportOpenPage() {
  const { token } = useParams()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!token) return
    const headers: Record<string, string> = {}
    const access = getAccessToken()
    if (access) headers.Authorization = `Bearer ${access}`
    const base = API_BASE_URL.replace(/\/$/, '')
    fetch(`${base}/api/v1/timetable-export/dl/${encodeURIComponent(token)}`, { headers })
      .then(async response => {
        if (response.status === 401) {
          const next = `${window.location.pathname}${window.location.search}`
          window.location.href = `/login?next=${encodeURIComponent(next)}`
          return
        }
        if (response.status === 403) {
          setError('Kein Export-Recht für diesen Link.')
          return
        }
        if (!response.ok) {
          setError('Der Link ist nicht gültig.')
          return
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'stundenplan.zip'
        link.click()
        URL.revokeObjectURL(url)
      })
      .catch(() => setError('Der Link ist nicht gültig.'))
  }, [token])

  return <div className="p-6">{error || 'Download…'}</div>
}
